import React, { useEffect } from "react";
import Header from "./Header/Header";
import "./AnalyticsScreen.scss";
import BasicReports from "./BasicReports/BasicReports";
import { fetchBasicAnalyticsRequest } from "../../../redux/exam_analytics/analyticsSlice";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

const AnalyticsScreen = () => {
  const dispatch = useDispatch();

  const paperId = useSelector((s) => s.examSlice.paperId);

  const { basicAnalytics, loading, error } = useSelector(
    (s) => s.analyticsSlice
  );

  useEffect(() => {
    if (paperId) {
      dispatch(fetchBasicAnalyticsRequest());
    }
  }, [paperId, dispatch]);

  const apiData = basicAnalytics?.data || null;

 
  if (loading?.basic) {
    return (
      <div className="analytics-loader">
        <ClipLoader color="#C61C26" size={55} />
      </div>
    );
  }

 
  if (error?.basic) {
    return (
      <div className="analytics-error">
        <p>Error: {error.basic}</p>
      </div>
    );
  }

  return (
    <div className="analytics-wrapper">
      <Header paperName={apiData?.paper_name} />
      <BasicReports basicAnalytics={apiData} />
    </div>
  );
};

export default AnalyticsScreen;
